<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>应用列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加应用</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;margin-top:30px;">

      <el-table-column prop="company" label="使用方" width="150">
      </el-table-column>
      <el-table-column prop="appId" label="AppId" width="100">
      </el-table-column>
      <el-table-column prop="appSecret" label="AppSecret" width="180">
      </el-table-column>
      <el-table-column prop="eventNotifyUrl" label="事件通知URL" width="500">
      </el-table-column>
      <el-table-column prop="remark" label="备注">
      </el-table-column>
      <el-table-column prop="limitField" label="限制显示字段" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.limitField"
            :active-value="1"
            :inactive-value="0"
            @change="handleLimit(scope.row)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column prop="flag" label="是否启用" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.flag"
            :active-value="1"
            :inactive-value="0"
            @change="handleDisable(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!--<el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm" :inline-message="true">
        <input type="hidden" v-model="editForm.id"/>
        <el-form-item label="使用方" prop="company">
          <el-input size="small" v-model="editForm.company" auto-complete="off" placeholder="哪个公司使用"
          ></el-input>
        </el-form-item>
        <el-form-item label="AppId" prop="appId">
          <el-input size="small" v-model="editForm.appId" auto-complete="off" placeholder="建议4位数字"
                    style="width: 120px;" :disabled="isUpdate"></el-input>
        </el-form-item>
        <el-form-item label="AppSecret" prop="appSecret">
          <el-input size="small" v-model="editForm.appSecret" auto-complete="off" placeholder="建议16位随机字符串"
                    style="width: 200px;"></el-input>
          <el-button size="small" @click="random('appSecret')">随机生成</el-button>
        </el-form-item>
        <el-form-item>
          <div v-if="isUpdate" style="color:red;font-size: 10px;" class="">注意：如果变更appSecret，该appId需要重新获取accessToken
          </div>
        </el-form-item>

        <el-form-item label="后台账号" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="英文字母或数字"
                    style="width: 200px;" :disabled="isUpdate"></el-input>
        </el-form-item>
        <el-form-item label="后台密码" prop="password">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="建议16位随机字符串"
                    style="width: 200px;"></el-input>
          <el-button size="small" @click="random('password')">随机生成</el-button>
        </el-form-item>



        <el-form-item label="事件通知URL" prop="eventNotifyUrl">
          <el-input size="small" v-model="editForm.eventNotifyUrl" auto-complete="off"
                    placeholder="事件通知URL，由应用方提供，具体使用参考接口文档"></el-input>
        </el-form-item>
        <el-form-item label="允许访问" prop="allowAccess">
          <el-input type="textarea" rows="2" size="small" v-model="editForm.allowAccess" auto-complete="off"
                    placeholder="填允许访问的接口或接口前缀，多个用英文逗号隔开，不填则全部允许访问，例：/meridian,/user/list"
          ></el-input>
        </el-form-item>
        <el-form-item label="禁止访问" prop="denyAccess">
          <el-input type="textarea" rows="2" size="small" v-model="editForm.denyAccess" auto-complete="off"
                    placeholder="填禁止访问的接口或接口前缀，多个用英文逗号隔开，不填则全部不禁止访问，例：/tongue/detail"
          ></el-input>
          <el-form-item>
            <div style="color:#1811ff;font-size: 10px;" class="">说明：一个接口能正常访问，需同时满足允许访问与禁止访问配置。</div>
          </el-form-item>
        </el-form-item>
        <el-form-item label="是否强制改善" prop="forceImprove">
          <el-switch
            v-model="editForm.forceImprove"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="用途、场景说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    loadApp, deleteApp, enableApp, setAppLimit, saveOrUpdateApp
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  import {randomStr} from '../../utils/util'

  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        isUpdate: false,
        bfVisible: false,
        title: '添加',
        editForm: {
          company: '',
          appId: '',
          appSecret: '',
          eventNotifyUrl: '',
          remark: '',
          allowAccess: '',
          denyAccess: '',
          username:'',
          password:'',
          forceImprove: 0
        },
        result: {
          diagnose: {},
          advices: []
        },
        businessForm: {},

        formInline: {
          pageNum: 1,
          pageSize: 10
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        list: []

      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      getdata(parameter) {
        this.loading = true
        loadApp(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row !== undefined && row !== 'undefined') {
          this.isUpdate = true
          this.title = '修改'
          this.editForm = row
        } else {
          this.isUpdate = false
          this.title = '添加'
          this.editForm = {}
        }
      },
      handleSearch: function (index, row) {
        this.getdata(this.formInline)
      },
      handleDelete: function (index, row) {
        this.$confirm('确定要删除【' + row.appId + '】吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            deleteApp({
              id: row.id
            })
              .then(res => {
                if (res.code === '0000') {
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            console.log('cancel delete..');
          })
      },
      handleDisable: function (row) {
        console.log(row)
        enableApp({
          id: row.id,
          flag: row.flag
        })
          .then(res => {
            if (res.code === '0000') {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
      },
      handleLimit: function (row) {
        setAppLimit({
          id: row.id,
          limit: row.limitField
        })
          .then(res => {
            if (res.code === '0000') {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        saveOrUpdateApp(this.editForm)
          .then(res => {
            this.loading = false
            if (res.code === '0000') {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.editFormVisible = false
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
      },
      submitBusinessForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            tutorBusinessSaveUpdate(this.businessForm)
              .then(res => {
                this.loading = false
                if (res.code == 0) {
                  this.bfVisible = false
                  this.getdata(this.formInline);
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
        this.getdata()
      },
      random: function (key) {
        let ran = randomStr()
        console.log(ran)
        this.$set(this.editForm, key, ran)
      },
      closeBfDialog() {
        this.bfVisible = false;
      },

      handleAvatarSuccess(res, file) {
        if (res.code == 0) {
          this.editForm.avatarUrl = res.data.url;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      },
      beforeAvatarUpload(file) {
        const formatOk = (file.type === 'image/jpeg' || file.type === 'image/png');
        const sizeLt1M = file.size / 1024 / 1024 < 1;

        if (!formatOk) {
          this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        }
        if (!sizeLt1M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return formatOk && sizeLt1M;
      },
      editBusiness(index, row) {
        this.bfVisible = true;
        this.result = row
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/list.vue